var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-bottom-container"},[_c('div',{staticClass:"header-bottom-container__grid"},[_c('FilterAZ'),_vm._v(" "),_c('TheSearch')],1),_vm._v(" "),(_vm.showBreadcrumbs)?_c('Breadcrumbs',{staticClass:"header-bottom-container__breadcrumbs",attrs:{"path":_vm.$route.path}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }